export default class MapsState {}
